/** @jsxImportSource @emotion/react */
import { Box, Card, CardContent, CircularProgress, css, Grid, Skeleton } from '@mui/material'
import { CenteredBox } from '@app/components/ui/CenteredBox/CenteredBox'

const AdminCardLoading = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2} width="100%">
      <Card css={metricCard}>
        <CardContent>
          <Skeleton variant="text" width={100} />
          <Box marginTop={5}>
            <CenteredBox>
              <CircularProgress size={20} />
            </CenteredBox>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default AdminCardLoading
const metricCard = css`
  border-radius: 12px;
  min-height: 120px;
`
